// Wall-mounted gallery layout with center attraction
export const mockPaintings = [
  // North Wall (Back wall)
  {
    id: 1,
    title: "A Heard of love",
    artist: "David Raj Paul",
    description: "A heard of love in the serenity of dusk - where the day rests, and the night watches over in silence",
    // imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Van_Gogh_-_Starry_Night_-_Google_Art_Project.jpg/1280px-Van_Gogh_-_Starry_Night_-_Google_Art_Project.jpg",
    imageUrl: "/paintings/painting_heard_of_love.png",
    // youtubeUrl: "https://www.youtube.com/watch?v=4xBYHgbqRp8", // Replace with your actual YouTube URL
    youtubeUrl: "https://www.youtube.com/watch?v=4xBYHgbqRp8", // Replace with your actual YouTube URL
    side: "north",
    position: { x: -8, y: 0.3, z: -11.5 },
    rotation: { x: 0, y: 0, z: 0 },
    size: { width: 2.5, height: 2.0 },
    cameraOffset: { x: 0, y: 3, z: 0.3 }   // field for controlling camera distance from the painting
  },
  {
    id: 2,
    title: "Nature's Adrenaline",
    artist: "David Raj Paul",
    description: "A famous Japanese woodblock print",
    imageUrl: "/paintings/painting_natures_adrenaline.png",
    youtubeUrl: "https://www.youtube.com/shorts/QnmdhR4-hbc", // Replace with your actual YouTube URL
    side: "north",
    position: { x: 0, y: 0.3, z: -11.5 },
    rotation: { x: 0, y: 0, z: 0 },
    size: { width: 2.5, height: 2.5 },
    cameraOffset: { x: 0, y: 3, z: 0.3 }
  },
  {
    id: 3,
    title: "The Sunlight and Meadow",
    artist: "David Raj Paul",
    description: "The world's most famous portrait",
    imageUrl: "/paintings/painting_sunlight_and_meadow.png",
    youtubeUrl: "https://www.youtube.com/shorts/QkmyXTqcX_U", // Replace with your actual YouTube URL
    side: "north",
    position: { x: 8, y: 0.3, z: -11.5 },
    rotation: { x: 0, y: 0, z: 0 },
    size: { width: 1.8, height: 2.5 },
    cameraOffset: { x: 0, y: 3, z: 0.3 }
  },
  
  // East Wall (Right wall)
  {
    id: 4,
    title: "The Golden Sunset",
    artist: "David Raj Paul",
    description: "Every sunset brings the promise of a new dawn.",
    imageUrl: "/paintings/painting_the_golden_sunset.jpg",
    youtubeUrl: "https://www.youtube.com/watch?v=u7BGXl-SOIA", // Replace with your actual YouTube URL
    side: "east",
    position: { x: 11.5, y: 0.3, z: -8 },
    rotation: { x: 0, y: -Math.PI / 2, z: 0 },
    size: { width: 3.0, height: 2.5 },
    cameraOffset: { x: -0.3, y: 3, z: 0 }
  },
  {
    id: 5,
    title: "The Rhythm of Rain",
    artist: "David Raj Paul",
    description: "Every drop creates a note in nature’s symphony.",
    imageUrl: "/paintings/painting_melody_of_the_rain.png",
    youtubeUrl: "https://www.youtube.com/watch?v=xLqOO8YPSuc", // Replace with your actual YouTube URL
    side: "east",
    position: { x: 11.5, y: 0.3, z: 0 },
    rotation: { x: 0, y: -Math.PI / 2, z: 0 },
    size: { width: 2.5, height: 2.5 },
    cameraOffset: { x: -0.3, y: 3, z: 0 }
  },
  {
    id: 6,
    title: "Guardian of the Wild",
    artist: "David Raj Paul",
    description: "Even the fiercest hearts turn gentle when protecting their own.",
    imageUrl: "/paintings/painting_tiger_mom.jpg",
    youtubeUrl: "https://www.youtube.com/watch?v=1MkHiY7Gz60", // Replace with your actual YouTube URL
    side: "east",
    position: { x: 11.5, y: 0.3, z: 8 },
    rotation: { x: 0, y: -Math.PI / 2, z: 0 },
    size: { width: 2.5, height: 2.5 },
    cameraOffset: { x: -0.3, y: 3, z: 0 }
  },
  
  // South Wall (Front wall - entrance area)
  {
    id: 7,
    title: "The Bonfire",
    artist: "David Raj Paul",
    description: "From the quiet spark, greatness begins.",
    imageUrl: "/paintings/painting_the_bonfire.png",
    youtubeUrl: "https://www.youtube.com/watch?v=FlUzLrsQ8SM", // Replace with your actual YouTube URL
    side: "south",
    position: { x: 5.5, y: 0.3, z: 11.5 }, // leaves room for the glass door in the middle
    rotation: { x: 0, y: Math.PI, z: 0 },
    size: { width: 2.3, height: 2.6 },
    cameraOffset: { x: 0, y: 3, z: -0.3 }
  },
  {
    id: 8,
    title: "The Moon of the Crusted Snow",
    artist: "David Raj Paul",
    description: "When silence falls on the frozen earth, the moon remembers every step once taken.",
    imageUrl: "/paintings/painting_the_moon_of_the_crusted_snow.png",
    youtubeUrl: "https://www.youtube.com/watch?v=NDDPNFZcFY8", // Replace with your actual YouTube URL
    side: "south",
    position: { x: -5.5, y: 0.3, z: 11.5 }, // leaves room for the glass door in the middle
    rotation: { x: 0, y: Math.PI, z: 0 },
    size: { width: 3.8, height: 2.6 },
    cameraOffset: { x: 0, y: 3, z: -0.3 }
  },
  
  // West Wall (Left wall)
  {
    id: 9,
    title: "Solitary with the Golden Moon",
    artist: "David Raj Paul",
    description: "In silence, the golden moon watches over all.",
    imageUrl: "/paintings/painting_solitary_with_the_golden_moon.jpg",
    youtubeUrl: "https://www.youtube.com/watch?v=YJUeH_0-ISQ", // Replace with your actual YouTube URL
    side: "west",
    position: { x: -11.5, y: 0.3, z: 4 },
    rotation: { x: 0, y: Math.PI / 2, z: 0 },
    size: { width: 2.2, height: 2.2 },
    cameraOffset: { x: 0.3, y: 3, z: 0 }
  },
  {
    id: 10,
    title: "The Meadow Within",
    artist: "David Raj Paul",
    description: "Into the meadow we go, to lose our mind and find our soul",
    imageUrl: "/paintings/painting_the_meadow_within.jpg",
    youtubeUrl: "https://www.youtube.com/watch?v=OTjGMudfIaw", // Replace with your actual YouTube URL
    side: "west",
    position: { x: -11.5, y: 0.3, z: -4 },
    rotation: { x: 0, y: Math.PI / 2, z: 0 },
    size: { width: 3.0, height: 2.3 },
    cameraOffset: { x: 0.3, y: 3, z: 0 }
  }
];

export const mockAudioTrack = {
  url: "https://commondatastorage.googleapis.com/codeskulptor-assets/Epoq-Lepidoptera.ogg",
  title: "Classical Gallery Music",
  artist: "Various Artists"
};

export const classicalTracks = [
  {
    url: "https://commondatastorage.googleapis.com/codeskulptor-assets/Epoq-Lepidoptera.ogg",
    title: "Ambient Gallery Music",
    artist: "Classical Collection"
  }
];

export const gallerySettings = {
  environment: {
    lightingIntensity: 0.8,
    ambientColor: "#ffffff",
    directionalColor: "#fff5e6",
    fogColor: "#f5f5f5",
    fogNear: 10,
    fogFar: 50
  },
  walls: {
    colorMap: '/textures/wall/marble_wall_Color.jpg',
    roughnessMap: '/textures/wall/marble_wall_Roughness.jpg',
    normalMap: '/textures/wall/marble_wall_NormalGL.jpg',
    repeat: [8, 8],
    roughness: 3,
    metalness: 0,
    textureScale: 1,
    height: 6,
    width: 24,
    depth: 24
  },
//   walls: {
//   colorMap: '/textures/wall/black/black_metal_wall_BaseColor.jpg',
//   roughnessMap: '/textures/wall/black/black_metal_wall_Roughness.jpg',
//   normalMap: '/textures/wall/black/black_metal_wall_Normal.png',
//   repeat: [8, 8],
//   roughness: 1.0,
//   metalness: 1.0,
//   textureScale: 1,
//   height: 5,
//   width: 24,
//   depth: 24
// },
  ceiling: {
    ceilingColorMap: '/textures/ceiling/ceiling_Color.png',
    roughnessMap: '/textures/ceiling/ceiling_Roughness.png',
    normalMap: '/textures/ceiling/ceiling_NormalGL.png',
    repeat: [8, 8],
    roughness: 0.7,
    metalness: 0.1,
    textureScale: 1,
    height: 6,
    width: 24,
    depth: 24
  },
  pillars: {
    pillarColorMap: '/textures/pillar/pillar_Color.png',
    roughnessMap: '/textures/pillar/pillar_Roughness.png',
    normalMap: '/textures/pillar/pillar_NormalGL.png',
    metalnessMap: '/textures/pillar/pillar_Metalness.png',
    repeat: [8, 8],
    roughness: 0.7,
    metalness: 0.1,
    radius: 0.4,
    height: 5,
    segments: 16
  },
  // floor: {
  //   // colorMap: '/textures/floor/wood_floor_Color.jpg',
  //   // roughnessMap: '/textures/floor/wood_floor_Roughness.jpg',
  //   // normalMap: '/textures/floor/wood_floor_Normal.jpg',
  //   colorMap: '/textures/floor/marble_floor_Color.png',
  //   roughnessMap: '/textures/floor/marble_floor_Roughness.png',
  //   normalMap: '/textures/floor/marble_floor_NormalGL.png',
  //   repeat: [8, 8],
  //   roughness: 0.1,
  //   metalness: 0.3,
  //   textureScale: 2
  // },
//   floor: {
//   colorMap: '/textures/floor/black/black_floor_tile_BaseColor.jpg',
//   roughnessMap: '/textures/floor/black/black_floor_tile_Roughness.jpg',
//   normalMap: '/textures/floor/black/black_floor_tile_Normal.png',
//   metalnessMap: '/textures/floor/black/black_floor_tile_Metallic.jpg',
//   repeat: [8, 8],
//   roughness: 1.0,
//   metalness: 1.0,
//   textureScale: 2
// },
floor: {
  colorMap: '/textures/floor/granite_tile_diff.jpg',         // Base color
  roughnessMap: '/textures/floor/granite_tile_arm.jpg',     // Used for roughness
  normalMap: '/textures/floor/granite_tile_ao_normal.jpg',  // Now using correct normal map
  repeat: [4, 4],
  roughness: 1,
  metalness: 0.0,
  textureScale: 2
},
  boundaries: {
    minX: -10,
    maxX: 10,
    minZ: -10,
    maxZ: 10,
    minY: 0.5,
    maxY: 4
  }
};
// URL-friendly id for a painting, e.g. "The Bonfire" -> "the-bonfire".
// Used for shareable links (/painting/<slug>) and the generated link-preview pages.
export const paintingSlug = (painting) =>
  painting.title
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// Optimised copies of each painting (generated from the originals in /paintings):
//   'texture' – what is hung on the 3D wall: 2048 px on desktop, 1024 px on phones (GPU memory!)
//   'large'   – details modal (2048 px)
//   'thumb'   – painting list (480 px)
//   'original'– full resolution, only for the zoomable image viewer
const IS_SMALL_SCREEN =
  typeof window !== 'undefined' && (window.innerWidth < 768 || /iPhone|iPad|Android/i.test(navigator.userAgent));
export const paintingImage = (painting, variant = 'texture') => {
  if (variant === 'original') return painting.imageUrl;
  const base = painting.imageUrl.replace(/^\/paintings\//, '').replace(/\.[a-z]+$/i, '');
  const folder = variant === 'thumb' ? 'thumbs' : variant === 'texture' && IS_SMALL_SCREEN ? '1024' : '2048';
  return `/paintings/${folder}/${base}.jpg`;
};
